var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCronJobs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 82,
    viewBox: "0 0 216 82",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.85 81H59.497c-5 0-9.054-3.582-9.054-8s4.054-8 9.054-8H9.054C4.054 65 0 61.418 0 57s4.054-8 9.054-8H60.79c5 0 9.054-3.582 9.054-8s-4.053-8-9.054-8H28.455c-5 0-9.054-3.582-9.054-8s4.054-8 9.054-8h51.737c-5 0-9.054-3.582-9.054-8s4.053-8 9.054-8h126.754c5 0 9.054 3.582 9.054 8s-4.054 8-9.054 8H155.21c5 0 9.053 3.582 9.053 8s-4.053 8-9.053 8h28.455c5 0 9.054 3.582 9.054 8s-4.054 8-9.054 8h-13.16c-6.304 0-11.415 3.582-11.415 8 0 2.946 2.587 5.612 7.76 8 5 0 9.054 3.582 9.054 8s-4.053 8-9.054 8Zm40.096-32c-5 0-9.054-3.582-9.054-8s4.054-8 9.054-8S216 36.582 216 41s-4.054 8-9.054 8ZM116 81c21.54 0 39-17.46 39-39S137.54 3 116 3 77 20.46 77 42s17.46 39 39 39Z",
    fillOpacity: 0.3,
    fill: "#7F7F7F"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#6A6666"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 39,
    r: 39,
    transform: "translate(76 2)",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.577 62.397c11.817 14.593 33.227 16.843 47.82 5.026 14.593-11.817 16.843-33.227 5.026-47.82-11.817-14.593-33.227-16.843-47.82-5.026-14.593 11.817-16.843 33.227-5.026 47.82Z",
    strokeDasharray: 206,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.577 62.397c11.817 14.593 33.227 16.843 47.82 5.026 14.593-11.817 16.843-33.227 5.026-47.82-11.817-14.593-33.227-16.843-47.82-5.026-14.593 11.817-16.843 33.227-5.026 47.82Z",
    strokeDasharray: 206,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114 15.675v28.978M132 35.884l-18 8.77",
    strokeWidth: 2,
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCronJobs);
export default __webpack_public_path__ + "static/media/cron-jobs.f08efd4689abb66bfb45539d80409640.svg";
export { ForwardRef as ReactComponent };